export default class FileService {
    constructor($http, appConfig) {
      "ngInject";
  
      this.$http = $http;
      this.appConfig = appConfig;
    }

    getQuotation(enquiryQuoteId) {
        const frm = $('#frmPrint');
        frm.attr('action', this.appConfig.apiServiceBaseUri + `api/file/getquote/${enquiryQuoteId}`);    
        frm.submit();   
    }   

    exportVehicles(entityId) {
      const frm = $('#frmPrint');
      frm.attr('action', this.appConfig.apiServiceBaseUri + `api/vehicle/publish/${entityId}`);    
      frm.submit();   
  }     
  
  getWebLeadFollowUpEmailTemplate(entityId, enquiryId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/file/getwebleadfollowupemailtemplate/${entityId}/${enquiryId}`);
  }     

  removeFollowUpImage(enquiryId, fileName) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/file/remove/followupimage/${enquiryId}?fullUrl=${fileName}`);
  }

}


// WEBPACK FOOTER //
// ./client/app/common/services/file.service.js